import { useCallback, useState } from "react";

// Storage key that marks the anonymous "first mutation" prompt as already
// shown. When the user signs in successfully we clear this key so a fresh
// anon session (e.g. logout + new device) starts clean again.
export const ANON_PROMPT_SHOWN_KEY = "flightplan_anon_prompt_shown";

/**
 * Hook that returns:
 *   - open: current dialog open state
 *   - setOpen: manual override
 *   - reason: last reason passed
 *   - nudge(reason): open the modal ONCE per session (uses localStorage flag).
 *   - show(reason): FORCE-open the modal every time (bypasses one-shot flag).
 *     Use this for actions that MUST be auth-gated every time, like opening
 *     the departure-profile form.
 */
export function useAnonPrompt() {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");

  const nudge = useCallback((r) => {
    let alreadyShown = false;
    try { alreadyShown = localStorage.getItem(ANON_PROMPT_SHOWN_KEY) === "1"; } catch { /* noop */ }
    if (alreadyShown) return;
    try { localStorage.setItem(ANON_PROMPT_SHOWN_KEY, "1"); } catch { /* noop */ }
    setReason(r || "");
    setOpen(true);
  }, []);

  const show = useCallback((r) => {
    setReason(r || "");
    setOpen(true);
  }, []);

  return { open, setOpen, reason, nudge, show };
}

export function resetAnonPromptShown() {
  try { localStorage.removeItem(ANON_PROMPT_SHOWN_KEY); } catch { /* noop */ }
}
